import usePropertyRateTierProgression from 'loyalty/hooks/usePropertyRateTierProgression'
import useUserTierProgress from 'loyalty/hooks/useUserTierProgress'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import TierProgressionBanner from './TierProgressionBanner'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'

interface Props {
  className?: string
  property: App.Property.Property | undefined
  rates: Array<App.EnrichedPropertyRate>
  nights: number
  checkoutDate?: string
  isUltraLux?: boolean
}

function PropertyTierProgressionPanel({ className, property, rates, nights, checkoutDate, isUltraLux }: Props) {
  const {
    showTierProgressionBanner,
    lowestUnlockableTier,
    lowestUnlockableTierName,
    highestUnlockableTier,
    highestUnlockableTierName,
    hasMultipleTierJumps,
    isLoading,
    statusReviewDate,
  } = usePropertyRateTierProgression({
    property,
    rates,
    nights,
    checkoutDate,
    isUltraLux,
    skip: rates.length === 0 || nights <= 0,
  })

  const isTierProgressionExperimentEnabled = !!useOptimizelyExperiment(
    OptimizelyExperiments.croTierProgressionOfferPage,
    showTierProgressionBanner && !isLoading,
  )

  const { creditsNeeded, nightsNeeded } = useUserTierProgress()

  if (!isTierProgressionExperimentEnabled || isLoading || !showTierProgressionBanner) {
    return null
  }

  return (
    <TierProgressionBanner
      className={className}
      lowestUnlockableTier={lowestUnlockableTier}
      lowestUnlockableTierName={lowestUnlockableTierName}
      highestUnlockableTier={highestUnlockableTier}
      highestUnlockableTierName={highestUnlockableTierName}
      hasMultipleTierJumps={hasMultipleTierJumps}
      statusCreditsNeeded={creditsNeeded}
      nightsNeeded={nightsNeeded}
      statusReviewDate={statusReviewDate}
      checkoutDate={checkoutDate}
    />
  )
}

export default withMountGuard(() => {
  return useAppSelector(getIsCurrentRegionUserLoyaltyRegion)
})(PropertyTierProgressionPanel)
